/**
 * Sizing tokens come from Slate sizing
 * https:slate.faire.team/foundations/icons/design#sizing
 */ export var Sizing = /*#__PURE__*/ function(Sizing) {
    Sizing["SIZING_UNKNOWN"] = "SIZING_UNKNOWN";
    /**
   * 16x16px
   */ Sizing["SIZING_S"] = "SIZING_S";
    /**
   * 24x24px
   */ Sizing["SIZING_M"] = "SIZING_M";
    /**
   * 32x32px
   */ Sizing["SIZING_L"] = "SIZING_L";
    return Sizing;
}({});
